<template>
  <div class="company-logo d-flex justify-content-center">
    <div
      @click="onLogoClicked"
      class="d-flex logo-wrap justify-content-center align-items-center"
    >
      <b-img
        v-if="showLogoPreview || logoSaved"
        :src="company.LogoPreview"
        fluid
        alt="Responsive image"
      ></b-img>
      <b-img
        v-if="!showLogoPreview && showLogo && !logoSaved"
        :src="data.logo_image"
        fluid
        alt="Responsive image"
      ></b-img>
      <img
        v-if="!showLogoPreview && !showLogo && !logoSaved"
        :src="uploadIconSvg"
        class="icon-svg"
      />
      <input
        class="logo-input"
        accept="image/jpeg, image/png, image/gif"
        type="file"
        ref="logoInput"
        @change="onLogoChange"
      />
    </div>
  </div>
</template>

<script>
import uploadIcon from "@/assets/icons/black/upload.svg";
import S3Utils from "@/utils/aws-s3";
export default {
  data() {
    return {
      uploadIconSvg: uploadIcon,
      logoFile: {},
      logoSaved: false,
      company: {}
    };
  },
  computed: {
    showLogo() {
      return this.data.logo_image !== undefined && this.data.logo_image !== "";
    },
    showLogoPreview() {
      return (
        this.company.LogoPreview !== undefined &&
        this.company.LogoPreview !== ""
      );
    }
  },
  props: {
    data: null
  },
  methods: {
    onLogoClicked() {
      this.$refs.logoInput.click();
    },
    onLogoChange(event) {
      event.preventDefault();
      this.logoFile = this.$refs.logoInput.files[0];
      if (!this.logoFile.name.includes(".")) {
        return;
      }
      this.$Progress.start();
      const payload = {
        fileName: this.logoFile.name.split(".").pop(),
        file: this.logoFile,
        callback: this.onLogoSaved
      };
      S3Utils.putFileToPreSignUrl(payload);
    },
    onLogoSaved(res) {
      if (res) {
        this.company.LogoPreview = res.dataPreview;
        this.data.logo_image = res.data;
        this.logoSaved = true;
      }
    }
  }
};
</script>
<style lang="scss">
@import "~@/assets/styles/core-variables";
.company-logo {
  .logo-wrap {
    border: 1px solid $grey-4;
    padding: 10px;
    width: 433px;
    height: 248px;
    cursor: pointer;
    position: relative;
    &.landing-image-wrap {
      width: 100%;
    }
    .icon-svg {
      height: 48px;
    }
    .img-fluid {
      max-height: 100%;
    }
  }
  .logo-input {
    visibility: hidden;
    position: absolute;
    top: 0;
    left: 0;
  }
  &.no-cursor {
    cursor: default;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/EditLogoModal.vue